<vg-modal-threeds
    (closeEvent)="onCloseError3ds()"
    [show]="showModal3ds"
></vg-modal-threeds>
<vg-modal-error
    [show]="showGenericError"
    [title]="'vg_purchase_payment_vg_modal_error_p_title' | translate"
    [text]="msgError"
    [btnTitle]="
        'vg_purchase_payment_vg_modal_error_vg_button_title' | translate
    "
    (closeEvent)="onCloseError()"
></vg-modal-error>
<vg-modal-loader [show]="showLoader"></vg-modal-loader>
<div class="container shared-container mx-auto container-payment-page">
    <div class="row justify-content-center container-payment-info">
        <div class="col-12 col-md-5 card-size">
            <vg-button
                class="btn-back d-none d-sm-block"
                [icon]="'back-arrow'"
                [href]="'/purchase/custom' | formatUrl | async"
                [style]="'link'"
            >
                {{ 'vg_landing_all_bton-return-label' | translate }}
            </vg-button>
            <vg-button
                class="btn-back d-sm-none d-md-none d-lg-none d-xl-none"
                [icon]="'back-arrow'"
                [href]="'/purchase/custom' | formatUrl | async"
                [onlyIcon]="true"
                [style]="'link'"
            ></vg-button>
        </div>
        <div class="col-12 col-md-7"></div>
    </div>
    <div class="row justify-content-center container-payment-info">
        <div class="col-12 col-md-5 col-lg-5 card-size">
            <h1 class="text-h1 text-center text-md-start">
                {{ 'vg_landing_purchase_payment_h1-title' | translate }}
            </h1>
            <vg-card-giftcard-summary></vg-card-giftcard-summary>
            <vg-card-mailing></vg-card-mailing>
        </div>
        <div
            class="col-12 col-md-7 col-lg-7 card-size-2 info-payment card-size-outside"
        >
            <h2 class="purchase-payment-subtitle forma-de-pago">
                {{ 'vg_landing_purchase_payment_method-title' | translate }}
            </h2>
            <vg-card-payment
                (changes)="onChangesFormPayment($event)"
            ></vg-card-payment>
            <vg-card-terms-conditions
                [enabledFinish]="formPayment.valid"
                [loading]="loading"
                (finish)="onFinish()"
                class="d-none d-lg-block"
            ></vg-card-terms-conditions>
        </div>
    </div>
</div>
<vg-card-terms-conditions
    [enabledFinish]="formPayment.valid"
    [loading]="loading"
    (finish)="onFinish()"
    class="vg-card-terms-conditions-mobile w-100 d-block d-lg-none"
></vg-card-terms-conditions>
